module.exports = __webpack_public_path__ + "img/horizontal_7_5_7016.5948fc67.png";